import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "col-md-12"
}
const _hoisted_2 = { class: "mb-3" }
const _hoisted_3 = { class: "mt-1" }
const _hoisted_4 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _component_SimpleCaseSolution = _resolveComponent("SimpleCaseSolution")!
  const _component_ComplexCaseSolution = _resolveComponent("ComplexCaseSolution")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.loading && _ctx.caseModel == null)
      ? (_openBlock(), _createBlock(_component_v_skeleton_loader, {
          key: 0,
          type: "article, actions"
        }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_ctx.caseModel)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_ctx.isSuccessful)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                      _createElementVNode("div", _hoisted_2, [
                        _cache[0] || (_cache[0] = _createElementVNode("h1", null, "Case set to solved", -1)),
                        _createElementVNode("div", _hoisted_3, " Case title: " + _toDisplayString(_ctx.caseModel.title), 1)
                      ]),
                      _cache[1] || (_cache[1] = _createElementVNode("div", null, [
                        _createElementVNode("p", null, "Thank you for your Feedback."),
                        _createElementVNode("p", null, "We have closed the case in our system."),
                        _createElementVNode("p", { class: "mt-2" }, " In case you have further questions or feedback, please reply to the latest E-Mail you have received from ifm-support@bmwgroup.com regarding this case. ")
                      ], -1))
                    ]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (!_ctx.isComplexSolution)
                        ? (_openBlock(), _createBlock(_component_SimpleCaseSolution, {
                            key: 0,
                            "case-model": _ctx.caseModel,
                            onSolve: _ctx.simpleSolveHandler
                          }, null, 8, ["case-model", "onSolve"]))
                        : (_openBlock(), _createBlock(_component_ComplexCaseSolution, {
                            key: 1,
                            "case-model": _ctx.caseModel,
                            onSolve: _ctx.solveComplexHandler
                          }, {
                            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                              _createTextVNode(" Board Case ", -1)
                            ]))]),
                            _: 1
                          }, 8, ["case-model", "onSolve"]))
                    ], 64))
              ], 64))
            : (_openBlock(), _createElementBlock("h1", _hoisted_4, "Error!"))
        ], 64))
  ]))
}